<template>
  <div class="d-inline-flex ma-1">
    <template v-if="anchor">
      <a @click="showModal">Receipt</a>
    </template>
    <template v-else>
      <v-btn class="ma-0 pa-0" color="primary" depressed small @click="showModal"><v-icon class="mr-1" style="color: var(--v-primary-lighten4) !important;" small>receipt</v-icon>Receipt</v-btn>
    </template>

    <v-dialog v-model="enabled" max-width="800px" @keydown.esc.prevent="enabled = false">
      <v-toolbar dense>
        <v-toolbar-title>Receipt</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="primary" @click.native="enabled = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <ReceiptPanel :transaction="transaction"></ReceiptPanel>
    </v-dialog>
  </div>
</template>

<script>
import Bus from '@/bus'

import ReceiptPanel from './Receipt.vue'

export default {
  components: {ReceiptPanel},

  data: function () {
    return {
      enabled: false
    }
  },

  props: {
    transaction: Object,
    anchor: Boolean
  },

  beforeDestroy () {
    Bus.$off('closeOptionsModal')
  },

  mounted () {
    Bus.$on('closeOptionsModal', this.closeModal)
  },

  methods: {
    showModal () {
      this.enabled = true
    },
    closeModal () {
      this.enabled = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/ReceiptModal.vue